import { authRoute } from "@/router/route/authRoute.tsx";
import { dashboardRoute } from "@/router/route/dashboardRoute.tsx";
export const checkAuthentication = (routeAuth, currentAuth) => {
    if (typeof routeAuth === 'undefined') {
        return false;
    }
    if (Array.isArray(routeAuth)) {
        return routeAuth.includes(currentAuth);
    }
    return routeAuth === currentAuth;
};
const initRoute = [];
export const routes = initRoute.concat(authRoute, dashboardRoute);
